import { categoryColor } from '../theme/customColors'
import serviceWebsite from '../assets/images/service-website.svg'
import content from '../assets/images/content.svg'
import local from '../assets/images/local.svg'
// import advertising from '../assets/images/advertising.svg'
import designStudio from '../assets/images/design_studio_logo_for_stripe.svg'
import { type IProduct, type IPrice, type ISubscription } from '../redux/api/types'

export interface IPlan {
  name?: string
  features?: string[]
  price?: number
  interval?: string
  productId?: string
  status?: string
  priceId?: string
  rank?: string
  active: boolean
}

export interface IServicesList {
  bg?: string
  iconUrl: string
  title: string
  category: string
  description: string | null
  plans: IPlan[]
}

export function comparePrices (first: IPrice | undefined, second: IPrice | undefined) {
  if (!first?.interval || !first?.intervalCount || !second?.interval || !second?.intervalCount) {
    return 0
  } else {
    const firstInMonth = first.interval.toLowerCase() === 'year' ? first.intervalCount * 12 : first.intervalCount
    const secondInMonth = second.interval.toLowerCase() === 'year' ? second.intervalCount * 12 : second.intervalCount
    return firstInMonth - secondInMonth
  }
}

export default function buildServiceList (products: IProduct[] | null, prices: IPrice[], subscriptions: ISubscription[]): IServicesList[] {
  const servicesList = [
    {
      bg: categoryColor[1],
      iconUrl: serviceWebsite,
      title: 'Website',
      category: 'website',
      // text: 'Premium secure responsive website to drive leads',
      description: '',
      plans: []
    },
    {
      bg: categoryColor[2],
      iconUrl: content,
      title: 'Content',
      category: 'content',
      // text: 'This is a longer description of advertising and what we do and how great it is for your marketing and leads and stuff',
      description: '',
      plans: []
    },
    {
      bg: categoryColor[3],
      iconUrl: local,
      category: 'local_presence',
      title: 'Local Presence',
      // text: 'A rocket boost for your Local Presence as the local expert.',
      description: '',
      plans: []
    },
    /* {
      bg: categoryColor[4],
      iconUrl: advertising,
      title: 'Advertising',
      category: 'advertising',
      text: 'This is a longer description of advertising and what we do and how great it is for your marketing and leads and stuff',
      plans: []
    }, */
    {
      bg: categoryColor[5],
      iconUrl: designStudio,
      title: 'Design Studio',
      category: 'design_studio',
      // text: 'This is a longer description of advertising and what we do and how great it is for your marketing and leads and stuff',
      description: '',
      plans: []
    }
    /* {
      bg: null,
      iconUrl: null,
      title: null,
      category: null,
      text: null,
      plans: []
    } */
  ]
  products?.forEach((product: IProduct) => {
    const index = servicesList.findIndex((service) => service.category === product.category)
    if (index !== -1) {
      const subscription = subscriptions?.find((subscription: ISubscription) => subscription.product === product.id)
      const pricesByProduct = prices?.filter((price: IPrice) => price.product === product.id)
      let price: IPrice | null = null
      if (pricesByProduct != null) {
        if (subscription?.price) {
          const filtredPrice = pricesByProduct.find((price: IPrice) => price.id === subscription.price)
          price = filtredPrice ?? null
        } else {
          // if the price is not in the subscription - select a higher price
          pricesByProduct.sort((a, b) => comparePrices(a, b))
          price = pricesByProduct ? pricesByProduct[0] : null
        }
      }

      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      servicesList[index].plans.push({
        name: product?.name,
        features: product?.features,
        price: price?.amount,
        priceId: price?.id,
        interval: price?.interval,
        status: subscription?.status,
        productId: product.id,
        rank: product.rank,
        endsAt: subscription?.endsAt,
        description: product?.description,
        active: price?.active
      })
    }
  })
  const finalServiceList = servicesList.map((service) => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    const maxYourRank = service.plans.reduce((max, plan) => (plan?.rank && plan.rank > max ? plan.rank : max), service?.rank ?? 0)
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-expect-error
    // eslint-disable-next-line @typescript-eslint/no-confusing-void-expression
    const highTierDesc: any = service.plans.find(plan => plan.rank === maxYourRank)
    return {
      ...service,
      description: highTierDesc?.description
    }
  })
  return finalServiceList
}
